import moment from "moment";
import { WebAssetResponse, AttachmentResponse } from "@akitabox/api-client";
import { getHref } from "../../../utils/getHref";

import { Color } from "../../colors";

export function getAssetFieldValue(
  /** @todo remove any, use proper types */
  asset: any,
  /** @todo make field type as keyof asset */
  field: string,
  format?: (value?: string) => string
) {
  if (!asset || typeof asset !== "object" || !("values" in asset)) {
    return "";
  }

  const fieldValue = asset.values[field]?.value;
  if (!fieldValue) {
    return "";
  }

  if (format) {
    return format(fieldValue);
  }

  return fieldValue;
}

export function buildAttachmentRows(
  attachments: AttachmentResponse[],
  step = 4
) {
  const rows = [];

  let start = 0;
  let end = step;
  let remainingAttachments = attachments.length;

  while (remainingAttachments > 0) {
    const chunk = attachments.slice(start, end);

    rows.push(
      <tr key={remainingAttachments}>
        {chunk.map((attachment) => (
          <td key={attachment._id}>
            <figure
              className="image image_resized image-style-align-center asset-image-contained"
              style={{ width: "100%" }}
            >
              <img src={attachment.document.public_thumbnail_url_medium} />
              <figcaption>
                {formatDate(
                  attachment.document.last_mod_date ||
                    attachment.document.cre_date
                )}
              </figcaption>
            </figure>
          </td>
        ))}
      </tr>
    );

    end += step;
    start += step;
    remainingAttachments--;
  }

  return rows;
}

export function formatDate(datetime?: string) {
  return !datetime ? "" : moment(datetime).format("MMM D, YYYY");
}

export function buildAssetHeader(asset: WebAssetResponse, colSpan?: number) {
  const baseUrl = getHref();
  const assetUrl = baseUrl + "/assets/" + asset._id;
  const buildingUrl = baseUrl + "/buildings/" + asset.building._id;
  return (
    <tr>
      <td colSpan={colSpan} style={{ backgroundColor: Color.LightGray }}>
        <strong>
          <a href={assetUrl} target="_blank" rel="noopener noreferrer">
            {asset.name}
          </a>
        </strong>{" "}
        -{" "}
        <a href={buildingUrl} target="_blank" rel="noopener noreferrer">
          {asset.building.name}
        </a>
      </td>
    </tr>
  );
}
